import { PaginationRequestInterface } from './pagination';
import { GridSortRequest, GridSortModel } from './sort';

export default class RecRegistryAccount {
  id = ""
  name = ""
  status = ""
  registeredPersonNumber = 0

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(obj: any) {
    Object.assign(this, obj)
  }
}

// Request

export class RecRegistryAccountRequest implements PaginationRequestInterface, GridSortRequest {
  search?: string
  serial?: number
  sort?: GridSortModel
  sortDesc?: boolean
  per = 25
  page = 0

  static copy(from: RecRegistryAccountRequest): RecRegistryAccountRequest {
    const newRequest = new RecRegistryAccountRequest()
    newRequest.search = from.search
    newRequest.sort = from.sort
    newRequest.sortDesc = from.sortDesc
    newRequest.per = from.per
    newRequest.page = from.page

    return newRequest
  }
}
